module.exports = __webpack_public_path__ + "img/error_icon.43b8867f.png";